import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#course-trainnning-statistics",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "BCN Report")
  ])
], -1)
const _hoisted_3 = {
  id: "course-trainnning-statistics",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Choose Date")
], -1)
const _hoisted_15 = { class: "col-md-3 mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_21 = { class: "position-relative" }
const _hoisted_22 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#courseTReport",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "BCN Report")
  ])
], -1)
const _hoisted_24 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_25 = { class: "collapse show" }
const _hoisted_26 = { class: "card-body border-top p-4" }
const _hoisted_27 = { class: "row w-100 mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_29 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Industry Association/Organization "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "6"
    }, " Enrollment ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, " Total Enrolled "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, " BCN Registered "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, " BCN/Total Enrolled % "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, " NID Registered "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, " NID/Total Enrolled % ")
  ])
], -1)
const _hoisted_38 = { style: {} }
const _hoisted_39 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "9"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_41 = { class: "text-start" }
const _hoisted_42 = {
  key: 0,
  class: "border border-gray-400 text-center"
}
const _hoisted_43 = {
  colspan: "2",
  class: "fw-bold"
}
const _hoisted_44 = { class: "fw-bold" }
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = { class: "fw-bold" }
const _hoisted_47 = { class: "fw-bold" }
const _hoisted_48 = { class: "fw-bold" }
const _hoisted_49 = { class: "fw-bold" }
const _hoisted_50 = { class: "border border-gray-400 text-center" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "fw-bold"
}, " Grand Total (All Tranches) ", -1)
const _hoisted_52 = { class: "fw-bold" }
const _hoisted_53 = { class: "fw-bold" }
const _hoisted_54 = { class: "fw-bold" }
const _hoisted_55 = { class: "fw-bold" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "fw-bold" }
const _hoisted_59 = { class: "fw-bold" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                      options: _ctx.optionsTranche,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Tranche",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                      options: _ctx.optionsTPartner,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Training Partner",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.bcn_date,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bcn_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          style: {"width":"100%"},
                          onChange: _ctx.btnCheckStatus
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.bcnReport())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_16
                    ])
                  ])
                ]),
                (_ctx.showTrainningStatistics == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                  : _createCommentVNode("", true),
                (_ctx.showTrainningStatistics == true)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _hoisted_28,
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                      title: "Download Xlse",
                                      "data-v-54b12dc8": "",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTrainee()))
                                    }, _hoisted_31),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                      title: "Download PDF",
                                      "data-v-54b12dc8": "",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadPdf()))
                                    }, _hoisted_33),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                      title: "Print",
                                      "data-v-54b12dc8": "",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printPdf()))
                                    }, _hoisted_35)
                                  ])
                                ]),
                                _createElementVNode("table", _hoisted_36, [
                                  _hoisted_37,
                                  _createElementVNode("tbody", _hoisted_38, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.bcnReportInfo, (info, key) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", _hoisted_39, [
                                            _createElementVNode("b", null, _toDisplayString(info[0]?.trancheLabel), 1)
                                          ])
                                        ]),
                                        _hoisted_40,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info, (data, inx) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: inx,
                                            class: "border border-gray-400 text-center"
                                          }, [
                                            _createElementVNode("td", null, _toDisplayString(inx + 1), 1),
                                            _createElementVNode("td", _hoisted_41, _toDisplayString(data?.entity_short_name), 1),
                                            _createElementVNode("td", null, _toDisplayString(data?.target), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.total)), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.bcn)), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                          data?.bcn_percentage?.toFixed(2)
                                        )), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.nid)), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                          data?.nid_percentage?.toFixed(2)
                                        )), 1)
                                          ]))
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.bcnsubtotalInfo, (sub, key2) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: key2 }, [
                                            (key === key2)
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                                                  _createElementVNode("td", _hoisted_43, " Subtotal(" + _toDisplayString(info[0]?.trancheLabel) + ") ", 1),
                                                  _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.numberWithCommas(sub?.targetTrainee)), 1),
                                                  _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.numberWithCommas(sub?.enrollment)), 1),
                                                  _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.numberWithCommas(sub?.bcnregister)), 1),
                                                  _createElementVNode("td", _hoisted_47, _toDisplayString(((sub?.bcnregister/sub?.enrollment)*100).toFixed(2)), 1),
                                                  _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.numberWithCommas(sub?.nidregister)), 1),
                                                  _createElementVNode("td", _hoisted_49, _toDisplayString(((sub?.nidregister/sub?.enrollment)*100).toFixed(2)), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      ], 64))
                                    }), 128)),
                                    _createElementVNode("tr", _hoisted_50, [
                                      _hoisted_51,
                                      _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.numberWithCommas(this.TotalTrainee)), 1),
                                      _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.numberWithCommas(this.Totalenrollment)), 1),
                                      _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.numberWithCommas(this.TotalBcnRegister)), 1),
                                      _createElementVNode("td", _hoisted_55, [
                                        (_ctx.TotalTrainee > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(((_ctx.TotalBcnRegister/_ctx.Totalenrollment)*100).toFixed(2)), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_57, " 0 "))
                                      ]),
                                      _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.numberWithCommas(this.TotalnidRegister)), 1),
                                      _createElementVNode("td", _hoisted_59, [
                                        (_ctx.TotalTrainee > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(((_ctx.TotalnidRegister/_ctx.Totalenrollment)*100).toFixed(2)), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_61, " 0 "))
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])), [
                            [_directive_loading, _ctx.load]
                          ])
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}